<template>
  <div>
    <div class="toolbar">
      <el-input v-model="customerName" clearable placeholder="项目名称" style="width:160px" @keyup.enter.native="load" />
      <el-select v-model="pmUserId" clearable filterable placeholder="项目经理" style="width:180px">
        <el-option v-for="u in pmUsers" :key="u.id" :label="u.nickname || u.username" :value="u.id" />
      </el-select>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="开工开始"
        end-placeholder="开工结束"
        style="width:260px"
      />
      <el-input v-model="address" clearable placeholder="房源地址" style="width:200px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :loading="exporting" :disabled="!list.length" @click="onExport">导出</el-button>
    </div>
    <el-table
      :data="pageList"
      border
      v-loading="loading"
      show-summary
      :summary-method="summaryMethod"
    >
      <el-table-column prop="customerName" label="项目名称" min-width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-button type="text" @click="openProject(row)">{{ row.name || row.customerName || row.projectName || '-' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="房源地址" min-width="160" show-overflow-tooltip />
      <el-table-column prop="totalCost" label="总成本" width="110" align="right">
        <template slot-scope="{ row }">{{ money(row.totalCost) }}</template>
      </el-table-column>
      <el-table-column label="材料成本" align="center">
        <el-table-column prop="materialCost" label="成本" width="110" align="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="num(row.materialCost) > 0"
              type="text"
              @click="openMaterialDetail(row)"
            >{{ money(row.materialCost) }}</el-button>
            <span v-else>{{ money(row.materialCost) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialRatio" label="占比" width="90" align="right">
          <template slot-scope="{ row }">{{ percent(row.materialRatio) }}</template>
        </el-table-column>
        <el-table-column
          v-for="category in categories"
          :key="category.key"
          :label="category.name"
          align="center"
        >
          <el-table-column :prop="'categoryCost_' + category.key" label="成本" width="110" align="right">
            <template slot-scope="{ row }">{{ money(categoryCost(row, category.key)) }}</template>
          </el-table-column>
          <el-table-column :prop="'categoryRatio_' + category.key" label="占比" width="90" align="right">
            <template slot-scope="{ row }">{{ percent(categoryRatio(row, category.key)) }}</template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column label="人工成本" align="center">
        <el-table-column prop="laborCost" label="成本" width="110" align="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="num(row.laborCost) > 0"
              type="text"
              @click="openLaborDetail(row)"
            >{{ money(row.laborCost) }}</el-button>
            <span v-else>{{ money(row.laborCost) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="laborRatio" label="占比" width="90" align="right">
          <template slot-scope="{ row }">{{ percent(row.laborRatio) }}</template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="920px"
      top="6vh"
      append-to-body
    >
      <el-table :data="detailList" border v-loading="detailLoading" max-height="520" show-summary :summary-method="detailSummary">
        <template v-if="detailType === 'material'">
          <el-table-column prop="reqNo" label="申请单号" width="120" show-overflow-tooltip />
          <el-table-column prop="supplierName" label="供应商" min-width="120" show-overflow-tooltip />
          <el-table-column prop="materialName" label="材料名称" min-width="140" show-overflow-tooltip />
          <el-table-column prop="categoryName" label="分类" width="100" show-overflow-tooltip />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="qty" label="数量" width="90" align="right">
            <template slot-scope="{ row }">{{ money(row.qty) }}</template>
          </el-table-column>
          <el-table-column prop="costPrice" label="成本价" width="90" align="right">
            <template slot-scope="{ row }">{{ money(row.costPrice) }}</template>
          </el-table-column>
          <el-table-column prop="costAmount" label="成本金额" width="110" align="right">
            <template slot-scope="{ row }">{{ money(row.costAmount) }}</template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column prop="reqNo" label="申请单号" width="120" show-overflow-tooltip />
          <el-table-column prop="workerName" label="工人" width="100" show-overflow-tooltip />
          <el-table-column prop="workTypeName" label="工种" width="100" show-overflow-tooltip />
          <el-table-column prop="stageName" label="工序" width="100" show-overflow-tooltip />
          <el-table-column prop="itemName" label="事项" min-width="120" show-overflow-tooltip />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="qty" label="数量" width="90" align="right">
            <template slot-scope="{ row }">{{ money(row.qty) }}</template>
          </el-table-column>
          <el-table-column prop="price" label="单价" width="90" align="right">
            <template slot-scope="{ row }">{{ money(row.price) }}</template>
          </el-table-column>
          <el-table-column prop="amount" label="金额" width="110" align="right">
            <template slot-scope="{ row }">{{ money(row.amount) }}</template>
          </el-table-column>
        </template>
      </el-table>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  projectCostReport,
  exportProjectCostReport,
  projectCostMaterialDetail,
  projectCostLaborDetail
} from '../../api/report'
import { listUsers } from '../../api/sys'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'
import { monthRange, money, percent, num, downloadXlsx } from './format'

export default {
  name: 'ProjectCostReport',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    const range = monthRange()
    return {
      customerName: '',
      pmUserId: null,
      address: '',
      dateRange: [range.startDate, range.endDate],
      pmUsers: [],
      categories: [],
      list: [],
      loading: false,
      exporting: false,
      detailVisible: false,
      detailLoading: false,
      detailType: 'material',
      detailTitle: '',
      detailList: []
    }
  },
  created() {
    this.loadPmUsers()
    this.load()
  },
  methods: {
    money,
    percent,
    num,
    queryParams() {
      return {
        customerName: this.customerName || undefined,
        pmUserId: this.pmUserId || undefined,
        address: this.address || undefined,
        startDate: this.dateRange && this.dateRange[0],
        endDate: this.dateRange && this.dateRange[1]
      }
    },
    async loadPmUsers() {
      const res = await listUsers({ roleCode: 'PROJECT_MANAGER' })
      this.pmUsers = (res.data || []).filter(u => u.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await projectCostReport(this.queryParams())
        this.list = (res.data && res.data.list) || []
        this.categories = (res.data && res.data.categories) || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async onExport() {
      if (!this.list.length) {
        return this.$message.warning('暂无数据可导出')
      }
      this.exporting = true
      try {
        const res = await exportProjectCostReport(this.queryParams())
        downloadXlsx(res.data, '项目成本.xlsx')
      } catch (e) {
        this.$message.error('导出失败')
      } finally {
        this.exporting = false
      }
    },
    openProject(row) {
      if (!row.projectId) return
      this.$router.push({ path: '/project/detail', query: { id: row.projectId } })
    },
    async openMaterialDetail(row) {
      if (!row.projectId) return
      this.detailType = 'material'
      this.detailTitle = `材料成本明细 - ${row.customerName || row.name || ''}`
      this.detailVisible = true
      this.detailLoading = true
      this.detailList = []
      try {
        const res = await projectCostMaterialDetail({ projectId: row.projectId })
        this.detailList = (res.data && res.data.list) || []
      } catch (e) {
        this.$message.error('加载明细失败')
      } finally {
        this.detailLoading = false
      }
    },
    async openLaborDetail(row) {
      if (!row.projectId) return
      this.detailType = 'labor'
      this.detailTitle = `人工成本明细 - ${row.customerName || row.name || ''}`
      this.detailVisible = true
      this.detailLoading = true
      this.detailList = []
      try {
        const res = await projectCostLaborDetail({ projectId: row.projectId })
        this.detailList = (res.data && res.data.list) || []
      } catch (e) {
        this.$message.error('加载明细失败')
      } finally {
        this.detailLoading = false
      }
    },
    categoryCost(row, key) {
      return row && row.categoryCosts ? row.categoryCosts[key] : 0
    },
    categoryRatio(row, key) {
      return row && row.categoryRatios ? row.categoryRatios[key] : 0
    },
    detailSummary({ columns }) {
      const data = this.detailList || []
      const amountKey = this.detailType === 'material' ? 'costAmount' : 'amount'
      const amount = data.reduce((s, r) => s + num(r[amountKey]), 0)
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        if (col.property === amountKey) return money(amount)
        return ''
      })
    },
    summaryMethod({ columns }) {
      const data = this.list || []
      const total = data.reduce((s, r) => s + num(r.totalCost), 0)
      const material = data.reduce((s, r) => s + num(r.materialCost), 0)
      const labor = data.reduce((s, r) => s + num(r.laborCost), 0)
      const map = {
        customerName: '合计',
        totalCost: money(total),
        materialCost: money(material),
        materialRatio: percent(total ? material / total : 0),
        laborCost: money(labor),
        laborRatio: percent(total ? labor / total : 0)
      }
      this.categories.forEach(category => {
        const categoryTotal = data.reduce((sum, row) => {
          return sum + num(this.categoryCost(row, category.key))
        }, 0)
        map['categoryCost_' + category.key] = money(categoryTotal)
        map['categoryRatio_' + category.key] = percent(total ? categoryTotal / total : 0)
      })
      return columns.map((col, i) => {
        if (i === 0) return '合计'
        return map[col.property] || ''
      })
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
</style>
